
import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config';

export async function updatePolicyStatus( id, actionCode ) {
  const result = await axios
    .put(
      `${REACT_APP_API}/dispatch-actions?action_code=${actionCode}&id=${id}`
    )

  return result?.data
}
